import StatusTabs from './StatusTabs';

export default StatusTabs;
export type { StatusTab } from './StatusTabs';
